import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import DateRange from "../../components/DateRange/DateRange";
import { Search_icon } from "../../assets/img";
import { toast } from "react-toastify";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import moment from "moment";
import { get, post } from "../../Services/ApiHandler";
import { RZP_KEY, URLS } from "../../Services/Constant";
import { checkPermission } from "../redux/api/PermissionManager";
import Razorpay from "react-razorpay/dist/razorpay";

const MMCCanApprView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const property = location.state?.property;
  console.log("property view", property);

  const { mmc_plan } = property ?? {};
  const { amount, gst, total_amount, plan_days } = mmc_plan ?? {};

  const planFields = [
    { label: "Plan Amount", value: amount },
    { label: "GST", value: gst },
    { label: "Total Amount", value: total_amount },
    { label: "Plan Duration (Days)", value: plan_days },
  ];

  const [rejectPopup, setRejectPopup] = useState(false);
  const [reason, setReason] = useState("");
  const [popup, setPopup] = useState(false);
  const [desc, setDesc] = useState("");
  const [details, setDetails] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState({
    from: "",
    to: "",
    search: "",
  });
  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const FilteringData = (data) => {
    let filtered_list = [];
    if (selectedFilter.from && selectedFilter.to) {
      filtered_list = data.filter((item) => {
        const itemDate = moment(item.created_at, "YYYY-MM-DD");
        const from = selectedFilter.from
          ? moment(selectedFilter.from, "YYYY-MM-DD")
          : null;
        const to = selectedFilter.to
          ? moment(selectedFilter.to, "YYYY-MM-DD")
          : null;

        if (from && itemDate.isBefore(from)) return false;
        if (to && itemDate.isAfter(to)) return false;
        return true;
      });
    } else {
      filtered_list = data;
    }
    return filtered_list?.filter(
      (item) =>
        item?.desc
          ?.toLocaleUpperCase()
          .indexOf(selectedFilter.search.toLocaleUpperCase()) >= 0 ||
        item?.created_by
          ?.toLocaleUpperCase()
          .indexOf(selectedFilter.search.toLocaleUpperCase()) >= 0,
    );
  };

  useEffect(() => {
    getList();
  }, []);
  const getList = async () => {
    const res = await get(URLS.MMC_TICKET_LIST + property?.id + "/");
    console.log("tickets list", res);
    if (res?.status === "success") {
      setDetails(res?.data || []);
    }
  };

  const handleSubmit = () => {
    if (details.length === 0) {
      toast.error("Add Description");
      return;
    }
    navigate("/mmc-cancel-appr-view");
  };
  const handleReason = () => {
    if (!reason) {
      toast.error("Add Reason");
      return;
    }
    setRejectPopup(false);
    setReason("");
  };
  const addTicket = async () => {
    if (!desc) {
      toast.error("Enter Description");
      return;
    }
    let payload = {
      desc: desc,
      property_mmc_id: property?.property_mmc_id,
      mmc_cancel_request_id: property?.id,
    };
    const res = await post(URLS.MMC_TICKET_CREATE, payload);
    console.log("create ticket", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      setDesc("");
      setPopup(false);
      getList();
    }
  };
  const paymentInitiate = async (owner_id, property_id) => {
    console.log("Adasldlsad", owner_id, property_id, property);

    const res = await post(`${URLS.CREATE_MMC}${owner_id}/${property_id}/`);
    if (res?.status === "success") {
      const d = res?.data;
      const RazorpayOrderOptions = {
        key: RZP_KEY,
        image:
          "https://frontend.newvow.vowstays.com/static/media/logo-icon.adcfba19588c3cc82c9a.png",
        amount: Number(d?.total_amount) * 100, // Amount in paise
        currency: "INR",
        name: "Vow",
        description: "Monthly Subscription",
        subscription_id: d?.razorpay_subscription_id,
        handler: (response) => {
          // console.log("razorpay response", response);
          confirmPayment(response);
        },
        theme: {
          color: "#AE55F5",
        },
      };
      const razorpayInstance = new Razorpay(RazorpayOrderOptions);
      razorpayInstance.open();
    }
  };
  const confirmPayment = async ({
    razorpay_subscription_id,
    razorpay_signature,
    razorpay_payment_id,
  }) => {
    const payload = {
      success: "active",
      razorpay_payment_id: razorpay_payment_id,
      razorpay_signature: razorpay_signature,
      razorpay_subscription_id: razorpay_subscription_id,
    };

    const res = await post(URLS.VERIFY_MMC, payload);
    if (res?.status === "success") {
      toast.success("Payment Success");
    }
  };
  return (
    <div className="">
      <Topbar header={"MMC View"} subHead={"MMC Cancellation"} />
      <div className="d-flex flex-wrap gap-5 pb-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Property ID{" "}
          </p>
          <input
            className="input-box"
            value={property?.id}
            type="text"
            placeholder="Property ID"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Property Name
          </p>
          <input
            className="input-box"
            value={property?.property_name}
            type="text"
            placeholder="Property name"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Owner Name
          </p>
          <input
            className="input-box"
            value={property?.property_name}
            type="text"
            placeholder="Owner Name"
          />
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            City
          </p>
          <input
            value={property?.location}
            className="input-box"
            type="text"
            placeholder="Location"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Type
          </p>
          <input
            value={property?.category}
            className="input-box"
            type="text"
            placeholder="Type"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Requested Date
          </p>
          <input
            value={moment(property?.requested_at).format("DD-MM-YYYY")}
            className="input-box"
            type="text"
            placeholder="Requested Date"
          />
        </div>

        {planFields.map((item) => {
          return (
            <div className="col-md-5" key={item.label}>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                {item.label === "GST" ? `${item.label} %` : item.label}
              </p>

              <input value={item.value ?? ""} readOnly className="input-box" />
            </div>
          );
        })}

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Approved By
          </p>
          <input
            value={property?.approved_by}
            disabled
            className="input-box"
            type="text"
            placeholder="Requested Date"
          />
          {checkPermission("CAN-EDIT-MMC_CANCELLATION") && (
            <button
              onClick={() =>
                paymentInitiate(property?.owner_id, property?.property_id)
              }
              className="active-btn p-2 mt-2"
            >
              Repay
            </button>
          )}
        </div>
        <div className="col-md-5 d-flex ac-jb">
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Approved Date
            </p>
            <input
              value={moment(property?.requested_at).format("DD-MM-YYYY")}
              disabled
              className="input-box"
              type="text"
              placeholder="Approved Date"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Approved Time
            </p>
            <input
              value={moment(property?.requested_at).format("hh:mm")}
              disabled
              className="input-box"
              type="text"
              placeholder="Approved Time"
            />
          </div>
        </div>
      </div>
      <div className="d-flex ac-je mt-5 gap-3">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search here" />
        </div>
        <button onClick={() => setPopup(true)} className="active-btn">
          Add
        </button>
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb  mb-4">
              <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                Description
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setPopup(false);
                  setDesc("");
                }}
                className="pointer"
              />
            </div>
            <textarea
              style={{ minHeight: "130px", maxHeight: "300px" }}
              placeholder="Describe.."
              className="input-box"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            ></textarea>
            <div className="d-flex ac-jc px-2 mt-4">
              <button
                onClick={() => {
                  addTicket();
                }}
                className="submit-btn f2 w-40"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {rejectPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb  mb-4">
              <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                Reason For Approve/Reject ?
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setRejectPopup(false);
                  setReason("");
                }}
                className="pointer"
              />
            </div>
            <textarea
              style={{ minHeight: "130px", maxHeight: "300px" }}
              placeholder="Describe.."
              className="input-box"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            ></textarea>
            <div className="d-flex ac-jc px-2 mt-4">
              <button
                onClick={() => {
                  handleReason();
                }}
                className="submit-btn f2 w-40"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="mt-5">
        <div className="d-flex ac-jb">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Ticket ID
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Admin Name
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-40 box-table">
            Description
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Date & Time
          </h4>
        </div>

        {FilteringData(details).map((item) => {
          return (
            <div className="d-flex mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 red w-20 box-table ">
                {item?.ticket_id}
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table">
                {item?.created_by}
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-40 box-table">
                {item?.desc}
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table">
                {moment(item?.created_at).format("DD-MM-YYYY hh:mm")}
              </h4>
            </div>
          );
        })}
      </div>

      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default MMCCanApprView;
